export const months = [
  {value: 1, text: "Enero"},
  {value: 2, text: "Febrero"},
  {value: 3, text: "Marzo"},
  {value: 4, text: "Abril"},
  {value: 5, text: "Mayo"},
  {value: 6, text: "Junio"},
  {value: 7, text: "Julio"},
  {value: 8, text: "Agosto"},
  {value: 9, text: "Septiembre"},
  {value: 10, text: "Octubre"},
  {value: 11, text: "Noviembre"},
  {value: 12, text: "Diciembre"}
];

export function last4Years() {
  const currentYear = new Date().getFullYear();
  return Array.from({length: 4}, (_, i) => currentYear - i);
}

export function currentYear() {
  return new Date().getFullYear();
}

export function currentMonth() {
  return new Date().getMonth() + 1;
}